export default () => ({
  allOperatorList: {
    count: 0,
    results: [],
  },
})
